import React from 'react'
import { formatShiftSlotLabel } from './shiftLabelUtils'

function ShiftLegend({ shiftDefs, lang, frameLabel }) {
    if (!shiftDefs?.length) return null

    return (
        <div className="flex_item_ce flex-wrap shift_badge_list">
            {shiftDefs.map((time) => {
                const badgeClass = `shift_badge badge_${
                    time?.name === 'A'
                        ? 'primary'
                        : time?.name === 'B'
                          ? 'success'
                          : time?.name === 'C'
                            ? 'warning'
                            : time?.name === 'D'
                              ? 'danger'
                              : 'default'
                }`

                return (
                    <span key={time?._id || time?.name} className={badgeClass}>
                        {formatShiftSlotLabel(time, { lang, frameLabel })}
                    </span>
                )
            })}
        </div>
    )
}

export default ShiftLegend
